import { oneOf, shape, string } from 'prop-types';

export default shape({
  text: string.isRequired,
  variant: string.isRequired,
  component: string.isRequired,
  alignment: oneOf(['center', 'left', 'right']).isRequired,
});
